module.exports = __webpack_public_path__ + "static/media/add-activity-icon-disabled.15bab105.png";